export default __webpack_public_path__ + "static/media/sign_in_1.64d318c6.webp";